/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";
import "react-toggle/style.css";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import Fade from "@material-ui/core/Fade";
import Icon from "react-icons-kit";
import { menu } from "react-icons-kit/iconic/menu";

import { Button, MediaQuery } from "UpduoLibrary";
import {
  skalePrimaryBlue,
  skaleWhite,
  upduoLightestGray,
  upduoPrimaryBlue,
} from "config/UpduoColors";
import { DashboardTableTabType } from "../types";
import TableTabBar from "./TableTabBar";
import TranscriptSearch from "./TranscriptSearch";
import { FilterSet } from "components/DashboardRoute/types";
import FilterTagRow from "./FilterTagRow";

interface TableHeaderProps {
  tableName: string;
  csvLoading: boolean;
  selectedTab: DashboardTableTabType;
  onTabChoice: (table: DashboardTableTabType) => void;
  handleExportCsv: () => void;
  filters: FilterSet;
  setFilters: React.Dispatch<React.SetStateAction<FilterSet>>;
  isUser: boolean;
}

export default function TableHeader({
  tableName,
  csvLoading,
  selectedTab,
  onTabChoice,
  handleExportCsv,
  filters,
  setFilters,
  isUser,
}: TableHeaderProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showTableMenu, setShowTableMenu] = useState(false);

  const _handleTableMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowTableMenu(true);
  };

  const _handleTableMenuClose = () => {
    setAnchorEl(null);
    setShowTableMenu(false);
  };

  return (
    <View
      style={{
        backgroundColor: skaleWhite,
        paddingHorizontal: 30,
        paddingVertical: 10,
        borderBottomWidth: 1,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        borderColor: upduoLightestGray,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TableTabBar
          isUser={isUser}
          shownTableType={selectedTab}
          onTabChoice={onTabChoice}
        />
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {tableName === "Activity" ? (
            <FilterTagRow filterSet={filters} setFilterSet={setFilters} />
          ) : null}
          {["Activity", "Session Progress"].includes(tableName) ? (
            <MediaQuery maxWidth={1299}>
              <View style={{ paddingRight: 10 }}>
                <ButtonBase
                  aria-haspopup={"true"}
                  onClick={_handleTableMenuClick}
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon size={25} icon={menu} />
                </ButtonBase>
                <Menu
                  id={"fade-menu"}
                  anchorEl={anchorEl}
                  open={showTableMenu}
                  onClose={_handleTableMenuClose}
                  TransitionComponent={Fade}
                >
                  <View
                    style={{
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      padding: 20,
                    }}
                  >
                    {tableName === "Activity" ? (
                      <View style={{ marginBottom: 16 }}>
                        <TranscriptSearch />
                      </View>
                    ) : null}
                    <Button
                      onPress={handleExportCsv}
                      text={"Export CSV"}
                      disabled={csvLoading}
                      height={36}
                      borderColor={skalePrimaryBlue}
                      color={upduoPrimaryBlue}
                    />
                  </View>
                </Menu>
              </View>
            </MediaQuery>
          ) : null}
          <MediaQuery minWidth={1300}>
            {/* Other than "Activity" table, all other tables have aggregated store rows, and will have expand/collapse toggle */}
            <>
              {tableName === "Activity" ? <TranscriptSearch /> : null}
              {["Activity", "Session Progress"].includes(tableName) ? (
                <Button
                  onPress={handleExportCsv}
                  text={"Export CSV"}
                  disabled={csvLoading}
                  height={36}
                  borderColor={skalePrimaryBlue}
                  color={upduoPrimaryBlue}
                />
              ) : null}
            </>
          </MediaQuery>
        </View>
      </View>
    </View>
  );
}
